module.exports = __webpack_public_path__ + "static/media/Physical_activity.bf6dddea.png";